import React from 'react';
import classes from './style.module.scss';
import Footer from '../Footer/Footer';

const Tournaments = () => {
    const tourInfo = [
        {
            name: 'Дисциплины турнира',
            text: [
                {
                    name: 'По вторникам:',
                    text: [
                        '«Свободная пирамида» (штраф — со стола на полку).',
                        'Верх до трех побед, низ до двух побед.',
                    ],
                },
                {
                    name: 'По четвергам:',
                    text: [
                        '«Корона».',
                        'Верх до трех побед (без нижней сетки).',
                    ],
                },
                {
                    name: 'По воскресеньям:',
                    text: [
                        '«Корона».',
                        'Верх до трех побед, низ до двух побед.',
                    ],
                },
            ],
        },
        {
            name: 'Вступительный взнос',
            text: [
                {
                    name: 'По вторникам и четвергам:',
                    text: '700 руб., без оплаты столов.',
                },
                {
                    name: 'По воскресеньям:',
                    text: '200 руб., оплата столов с проигравшего.',
                },
                {
                    name: 'Финальный турнир:',
                    text: '2000 руб., оплата столов с проигравшего. Топ игроки (4 или 8) вступительные взносы не платят.',
                },
            ],
        },
        {
            name: 'Призовой фонд:',
            text: [
                {
                    name: 'Итоговый турнир:',
                    text: [
                        '1 Место – Кий Легенда Тюльпан-2 трёхсоставной с тубусом, + минимум 40 тыс. руб.',
                        '2 Место – Кий Легенда Шахматы, + минимум 30 тыс. руб.',
                        '3 Место - Тубус Джуниор, комбо-набор из мела, перчатки, держателя для мела и полотенца, + минимум 20 тыс. руб.',
                        '4 Место – Комбо-набор из мела, перчатки, держателя для мела и полотенца, + минимум 10 тыс. руб.',
                        '5 - 8 Место – 5 000 рублей бонусами на клубную карту.',
                    ],
                },
                {
                    name: 'По вторникам, четвергам и воскресеньям',
                    text: [
                        '1 Место – 1 000 рублей бонусами на клубную карту.',
                        '2 Место – 750 рублей бонусами на клубную карту.',
                        '3 Место – 500 рублей бонусами на клубную карту.',
                    ],
                },
            ],
        },
    ];

    return (
        <div className={classes.page}>
            <div className={classes.container}>
                <div className={classes.tournamentContainer}>
                    <div>
                        <h3 className={classes.title}>
                            Рейтинговый турнир «Кубок Легенды» по пирамиде 2024г
                            (зима-весна)
                        </h3>
                        <h4 className={classes.dateOfTours}>
                            <span>НАЧАЛО ТУРНИРА: 16.01.2023 - 19:00</span>
                            <span>ФИНАЛ ТУРНИРА: 28.04.2024 - 12:00</span>
                        </h4>
                        <h5 className={classes.sportsType}>Вид спорта</h5>
                        <p className={classes.sportsTypeInfo}>
                            <span>Пирамида с гандикапом (с форой).</span>
                            <span>
                                Игроки будут разделены на группы согласно
                                накапливаемой статистики встреч, исходя из
                                разницы групп будет определяться фора.
                            </span>
                            <span>
                                Проводится турниры и считаться рейтинг будут на
                                площадке{' '}
                                <a href="https://fairplay.host/">FairPlay</a>.
                            </span>
                            <span>
                                Для участия в итоговом турнире необходимо
                                участвовать минимум в 12 отборочных турах.
                            </span>
                            <span>В финале будут участвовать 20 игроков.</span>
                            <span>
                                Топ-4 игрока в финальном турнире сеются в верх
                                сетки и не платят вступительные взносы в финал.
                            </span>
                            <span>
                                При количестве финалистов (отыгравших 12 игр и
                                более) более 20, первые 8 не платят взносы и
                                снятся вверх сетки.
                            </span>
                            <span>
                                Турнир считается состоявшимся при минимальном
                                количестве участников 4 человека. Итоговый
                                турнир: «Корона».
                            </span>
                            <span>
                                Итоговый призовой фонд складывается в
                                зависимости от количества участников, из расчета
                                200 рублей на участника в каждом туре.
                            </span>
                            <span>
                                Гарантированный призовой фонд 100 000 рублей
                            </span>
                        </p>
                        {tourInfo.map((item, index) => (
                            <div className={classes.tourInfo} key={index}>
                                <h5>{item.name}</h5>
                                {item.text.map((text, index) => (
                                    <div key={index}>
                                        <h6>{text.name}</h6>
                                        {Array.isArray(text.text) ? (
                                            text.text.map((text, index) => (
                                                <div key={index}>
                                                    <p>{text}</p>
                                                </div>
                                            ))
                                        ) : (
                                            <p>{text.text}</p>
                                        )}
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Tournaments;
